import React from "react";
import { PlayersServices } from "@/services";
import { Button } from "@/components/ui";
import { PlayerStickers } from "@/components";
import { PlayerStickerRequest } from "@/interfaces";
import { toast } from "sonner";
import { FormCard } from "@/components";

interface Props {
  playerId: number | string;
  withWritePermission: boolean;
}

export function PlayerStickersForm({ playerId, withWritePermission }: Props) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [stickerRequest, setStickerRequest] = React.useState<PlayerStickerRequest>();

  const updateStickers = (): void => {
    if (stickerRequest && playerId) {
      setLoading(true);
      PlayersServices.updatePlayerStickers(playerId, stickerRequest)
        .then(() => {
          toast.success("Stickers saved!");
        })
        .catch((e: string) => {
          toast.error(e.substring(0, 40));
        })
        .finally(() => {
          setLoading(false);
          setStickerRequest(undefined);
        });
    }
  };

  return (
    <FormCard>
      <FormCard.Header title={"Stickers"} description={"Upload custom stickers to personalize prompts"} />
      <FormCard.Content>
        <PlayerStickers
          withWritePermission={withWritePermission}
          playerId={playerId}
          onChange={setStickerRequest}
          onLoading={setLoading}
        />
      </FormCard.Content>
      <FormCard.Actions>
        <Button onClick={updateStickers} disabled={!stickerRequest || loading} loading={loading}>
          Save
        </Button>
      </FormCard.Actions>
    </FormCard>
  );
}
